import './assets/main.scss';
import './globals';

// slider
import '@vueform/slider/themes/default.css';

//bootstrap
import 'bootstrap';

//floating-vue
import 'floating-vue/dist/style.css';

//vue final modal
import 'vue-final-modal/style.css';

//vue3 toastify
import 'vue3-toastify/dist/index.css';

import { createApplication } from './app';

const app = createApplication();
app.mount('#app');
